<script lang="ts" setup>
import MarkdownBlock from '@monogrid/vue-boost/core/MarkdownBlock.vue'
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import { MenuPrimaryItemOptions, primaryItems } from '@/data/menu'
import { states } from '@/store'

import AppButtonText from '../atoms/AppButtonText.vue'
import ModalWrapper from '../molecules/ModalWrapper.vue'
import NavigationBar from '../molecules/NavigationBar.vue'

const route = useRoute()

const activeIndex = ref<number>(0)

const activeContent = computed<MenuPrimaryItemOptions>(() => (primaryItems[activeIndex.value]))

const updateActiveIndex = (index: number) => {
  activeIndex.value = index
}

watch(() => states.workingHours.visible, (visible) => {
  if (!visible) return
  const pageSlugParam = route.params.pageSlug
  if (route.path.includes(pageSlugParam as string)) {
    activeIndex.value = primaryItems.findIndex(item => item.id === pageSlugParam)
  }
})
</script>

<template>
  <ModalWrapper v-model:visible="states.workingHours.visible">
    <div class="min-h-full px-12.5 py-25 lg:py-15 grid grid-cols-12 items-center">
      <div class="col-span-12">
        <MarkdownBlock
          :text="$t('global.workingHours.title')"
          class="text-center tracking-wide text-10 line-height-12 lg:text-12 lg:line-height-15 mb-3"
          tag="h4"
          inline
        />
        <MarkdownBlock
          :text="$t('global.workingHours.subtitle')"
          class="text-center tracking-wide text-5"
          tag="p"
          inline
        />
        <NavigationBar
          v-model:current-index="activeIndex"
          :list="primaryItems"
          class="lt-lg:bg-white lt-lg:fixed lt-lg-z-10 lt-lg:left-4 lt-lg:right-4 lt-lg:bottom-0 lg:my-16"
        >
          <template #default="{ item, itemIndex, currentIndex }: { item: MenuPrimaryItemOptions, itemIndex: number, currentIndex:number }">
            <AppButtonText
              :active="itemIndex === currentIndex"
              :size="$breakpoints.lg ? 'md' : 'sm'"
              tabindex="0"
              @click="updateActiveIndex(itemIndex)"
            >
              {{ item.label[$i18n.locale] }}
            </AppButtonText>
          </template>
        </NavigationBar>
        <div v-if="activeContent" class="lt-lg:my-12.5">
          <ul class="grid grid-cols-12 lt-lg:text-center lt-lg:gap-y-10">
            <li class="col-span-12 lg:col-span-3 lg:col-start-3">
              <h5 class="font-semibold uppercase tracking-wide mb-4">{{ $t('global.workingHours.hours') }}</h5>
              <Transition mode="out-in">
                <MarkdownBlock
                  :key="activeContent.workingHours[$i18n.locale]"
                  :text="activeContent.workingHours[$i18n.locale]"
                  tag="p"
                  inline
                />
              </Transition>
            </li>
            <li class="col-span-12 lg:col-span-3 lg:col-start-8">
              <h5 class="font-semibold uppercase tracking-wide mb-4">{{ $t('global.workingHours.address') }}</h5>
              <Transition mode="out-in">
                <MarkdownBlock
                  :key="activeContent.address[$i18n.locale]"
                  :text="activeContent.address[$i18n.locale]"
                  tag="p"
                  inline
                />
              </Transition>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </ModalWrapper>
</template>
